module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageHomepageMainHeading":{"text":"Svět očima hudby"}},"en":{"PageHomepageMainHeading":{"text":"We connect creativity and technology."}}}')
  delete Component.options._Ctor
}
